// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nq2R","textarea":"styles_textarea__3KAm-"};